import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { updateNewReviewers } from "@api/preview/send"
import { Checkbox } from "@bitcine/cs-theme"

const EmailsFooter = ({ isNextDisabled, isCCEnabled, updateNewReviewers }) => {
  const [addCC, setAddCC] = React.useState(false)
  const [emails, setEmails] = React.useState("")
  return (
    <div>
      {addCC && <div className='border-top border-gray-5 pt2 mt2'>
        <div className='bg-gray-5 mb2 p1 rounded'>
          <div className='italic bold'>
             Note: CC addresses will receive a copy of all emails sent to reviewers. This is intended to be used for communication purposes. Emails on CC should not click on screener links as this may disrupt analytics and may affect enabled security measures.
          </div>
        </div>
        <div className=''>
          <label className='cs-label'>CC email addresses, separated by commas</label>
          <input
            label='CC Email Addresses'
            className='cs-input col-12 mr2'
            value={emails}
            onChange={e => setEmails(e.target.value)}
            onBlur={() => updateNewReviewers("email", "cc_email_addresses", emails)}
            placeholder='Enter CC email addresses, separated by commas'/>
        </div>
      </div>}
      <div className='mt3 flex justify-end'>
        <div className='flex items-center'>
          {isCCEnabled && 
            <Checkbox
              label='Add CC to emails'
              checked={addCC}
              onChange={() => {
                setAddCC(!addCC)
                updateNewReviewers("email", "add_cc", !addCC)
              }}/>
          }
          <button
            className='cs-button ml2'
            disabled={isNextDisabled}
            onClick={() => updateNewReviewers("email", "step", "sharing-options")}>
            Next: Sharing Options
          </button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isCCEnabled: state.user.auth.organization.can_use_cc_on_shared_emails
})

const mapDispatchToProps = dispatch => ({
  updateNewReviewers: bindActionCreators(updateNewReviewers, dispatch)
})

EmailsFooter.propTypes = {
  isNextDisabled: PropTypes.bool.isRequired,
  updateNewReviewers: PropTypes.func.isRequired,
  isCCEnabled: PropTypes.bool
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailsFooter)
